import { FC, useEffect, useState } from 'react';

// Third-party
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';

// Components
import { BaseDialog, TDialogAction } from '@mgm/common/components/base';

// Types
import { TNoteDialog } from '../type';

const NoteDialog: FC<TNoteDialog> = ({
  isOpenNoteDialog,
  handleClose,
  submissionNote,
  setSubmissionNote,
}) => {
  const { t } = useTranslation('common');
  const [note, setNote] = useState('');

  useEffect(() => {
    setNote(submissionNote);
  }, [submissionNote]);

  const addNote = () => {
    setSubmissionNote(note);
    handleClose();
  };

  const dialogActions: Array<TDialogAction> = [
    {
      label: t('cancel'),
      variant: 'outlined',
      color: 'primary',
      onClick: () => handleClose(),
    },
    {
      label: t('save'),
      color: 'primary',
      onClick: () => addNote(),
    },
  ];

  return (
    <BaseDialog
      dialogTitle={t('addNote', { ns: 'tasklists' })}
      dialogWidth={400}
      isOpenDialog={isOpenNoteDialog}
      dialogContent={(
        <TextField
          value={note}
          onChange={(event) => setNote(event.target.value)}
          multiline
          fullWidth
          sx={{
            width: 250,
          }}
          rows={5}
        />
      )}
      handleClose={handleClose}
      dialogActions={dialogActions}
    />
  );
};

export {
  NoteDialog,
};
